import React, { Component } from 'react';
import styles from './My-Test-List.module.scss';
import MaterialTable from 'material-table';

import { forwardRef } from 'react';
import { AddBox, Check, Clear, DeleteOutline, ChevronRight, Edit, SaveAlt, FilterList, FirstPage, LastPage, ChevronLeft, Search, ArrowDownward, Remove, ViewColumn } from "@material-ui/icons";

class MyTestListComponent extends Component {
    render() {

        function MaterialTableDemo(data) {
            const [state, setState] = React.useState({
                columns: [
                    { title: "Sr. No.", render: rowData => rowData.tableData.id + 1  },
                    { title: 'Patient Name', field: 'patient_name', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Mobile', field: 'mobile', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Total', field: 'patient_total', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Add Date', field: 'add_date', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Action', field: 'action', cellStyle: { fontSize: '.9rem' }, render: patientAction => (<a href={"https://lab.drray24.in/invoice/"+patientAction.invoice_id+"/"+patientAction.hash} target="_blanck" className={`my-btn ${styles.actionView}`}>View</a>)  },
                  ],
                  data: data.myTests,
            });

            const tableIcons = {
                Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
                Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
                Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
                DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
                Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
                Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
                FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
                LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
                NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
                ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
                SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
                ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
                ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
            }
          
            return (
              <MaterialTable
                title="Booked Test"
                columns={state.columns}
                data={state.data}
                icons={tableIcons}
              />
            );
        }

        return(
            <MaterialTableDemo myTests={this.props.myTests} />
        );
    }
}

export default MyTestListComponent;